import { useContext, useState } from "react";
import { Context } from "../../../context";
import { useNavigate } from "react-router-dom";
import { Box, IconButton, Toolbar } from "@mui/material";
import { TopNavigationWrapper } from "./styled";
import MenuIcon from '@mui/icons-material/Menu';
import { NotificationsUnreadIcon } from "../../../assets";
import { BaseDropDown } from "../../../components/modals/dropdown";
import { avatarOptions } from "../../../config/static";
import { BaseDropDownType } from "../../../types/app.type";
import { signOutUser } from "../../../utils/apis/authentication/signout";
import Cookies from "universal-cookie";

export const TopNavigation = ({ headshot }: { headshot: React.ReactNode }) => {
    const cookies = new Cookies();
    const TOKEN = cookies.getAll().TOKEN;

    const navigate = useNavigate();
    const { isSideNavigationClosing, mobileSideNavigationOpen, setMobileSideNavigationOpen } = useContext(Context);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [notifications, setNotifications] = useState([
        { title: "Hello User, Welcome to Guib", url: "" },
        { title: "Please update access roles", url: "" },
    ]);
    const [isAvatarDropDownOpen, setIsAvatarDropDownOpen] = useState(false);
    const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);

    const handleDrawerToggle = () => {
        if (!isSideNavigationClosing) {
            setMobileSideNavigationOpen(!mobileSideNavigationOpen);
        }
    };

    const handleAvatarOpen = () => {
        return setIsAvatarDropDownOpen(true);
    };

    const handleNotificationModalOpen = () => {
        setIsNotificationModalOpen(true);
    }

    const handleAvatarClose = () => {
        return setIsAvatarDropDownOpen(false);
    };

    const handleNotificationModalClose = () => {
        return setIsNotificationModalOpen(false)
    };

    const handleLogOutUser = async () => {
        try {
            const response = await signOutUser(TOKEN);
            if (response.status === "success") {
                cookies.remove("TOKEN", { path: '/' });
                navigate("/");
            } else {
                console.error('Logout failed. Try again');
            }
        } catch (error: any) {
            console.error('Logout failed, Contact Admin:', error);
        }
    }

    const handleAvatarItemClick = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, item: BaseDropDownType) => {
        e.preventDefault();
        switch (item.title) {
            case "Edit profile":
                navigate(item.url);
                setIsAvatarDropDownOpen(false);
                break;
            case "Settings":
            case "Help":
            case "Log out":
                handleLogOutUser();
                setIsAvatarDropDownOpen(false);
                break;
            default:
                break;
        }
    };

    const handleNotificationItemClick = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, item: BaseDropDownType) => {
        e.preventDefault();
        setIsNotificationModalOpen(false);
    };

    return (
        <TopNavigationWrapper>
            <Toolbar
                sx={{ justifyContent: "space-between" }}
            >
                <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{
                        color: "#791377",
                        visibility: { tablet: "hidden" }
                    }}
                    onClick={handleDrawerToggle}
                >
                    <MenuIcon />
                </IconButton>
                <Box
                    overflow={"hidden"}
                >
                    <IconButton
                        size="large"
                        aria-label="mailbox of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        color="inherit"
                        onClick={handleNotificationModalOpen}
                    >
                        <NotificationsUnreadIcon />
                    </IconButton>
                    <IconButton
                        size="large"
                        aria-label="Notifications for current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        color="inherit"
                        onClick={handleAvatarOpen}
                    >
                        {headshot}
                    </IconButton>
                </Box>
                <BaseDropDown
                    className="avatar-modal"
                    open={isAvatarDropDownOpen}
                    items={avatarOptions}
                    handleClose={handleAvatarClose}
                    handleItemClick={(e, item) => handleAvatarItemClick(e, item)}
                />
                <BaseDropDown
                    className="notification-modal"
                    open={isNotificationModalOpen}
                    items={notifications}
                    handleClose={handleNotificationModalClose}
                    handleItemClick={(e, item) => handleNotificationItemClick(e, item)}
                />
            </Toolbar>
        </TopNavigationWrapper >
    )
}